export const stageDisplayForJob = job => {
  return Array.from({ length: job.numStages }).map((_, i) => ({
    display: job[`stage${i + 1}Name`],
    value: (i + 1).toString()
  }));
};
